<template>
    <div>
        <b-form-tags
            v-model="selectedTags"
            :input-attrs="{ autocomplete: 'off' }"
            :tag-validator="validateTag"
            tag-variant="dark"
            separator=","
            placeholder="Type to add tags..."
            @input="handleTagsChange"
            class="p-0 border-0"
            :limit="20"
            remove-on-delete
            no-add-on-enter
            add-button-variant="primary"
        >
            <template #tag="{ tag, removeTag, disabled }">
                <b-badge
                    variant="info"
                    :disabled="disabled"
                    @click="removeTag(tag)"
                >{{ tag }}
                    <b-icon icon="x"></b-icon>
                </b-badge>
            </template>
        </b-form-tags>
        <b-form-invalid-feedback :state="validationState">
            {{ validationMessage }}
        </b-form-invalid-feedback>
    </div>
</template>

<script>
import { BFormTags, BIcon, BBadge, BFormInvalidFeedback } from 'bootstrap-vue'

export default {
    name: 'PostTagEditor',
    components: {
        BFormTags,
        BIcon,
        BBadge,
        BFormInvalidFeedback
    },
    props: {
        postId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            selectedTags: [],
            allTags: [],
            validationState: null,
            validationMessage: ''
        }
    },
    async created() {
        await this.fetchPostTags()
        await this.fetchAllTags()
    },
    methods: {
        async fetchPostTags() {
            try {
                const response = await this.$http.get(`/http_api/posts/${this.postId}/tags`)
                this.selectedTags = response.data.tags.map(tag => tag.tag)
            } catch (error) {
                console.error('Error fetching post tags:', error)
                this.validationMessage = 'Failed to fetch post tags'
                this.validationState = false
            }
        },
        async fetchAllTags() {
            try {
                const response = await this.$http.get('/http_api/tags')
                this.allTags = response.data.data.map(tag => tag.tag)
            } catch (error) {
                console.error('Error fetching all tags:', error)
            }
        },
        validateTag(tag) {
            return new Promise((resolve) => {
                if (tag.length < 2) {
                    this.validationState = false
                    this.validationMessage = 'Tag must be at least 2 characters long'
                    resolve(false)
                } else {
                    this.validationState = true
                    this.validationMessage = ''
                    resolve(true)
                }
            })
        },
        handleTagsChange(newTags) {
            // Ensure newTags is always an array, even if empty
            this.updatePostTags(newTags || [])
        },
        async updatePostTags(newTags) {
            try {
                const response = await this.$http.post(`/http_api/posts/${this.postId}/tags`, { tags: newTags })
                if (response.data) {
                    if (response.data.message) {
                        this.validationMessage = response.data.message
                    } else {
                        this.validationMessage = 'Tags updated successfully'
                    }
                    if (response.data.tags) {
                        this.selectedTags = response.data.tags.map(tag => tag.tag)
                        this.$emit('tags-updated', response.data.tags)
                    }
                    this.validationState = true
                } else {
                    this.validationMessage = 'Tags updated successfully'
                    this.validationState = true
                }
            } catch (error) {
                console.error('Error updating post tags:', error)
                this.validationState = false
                if (error.response && error.response.data && error.response.data.message) {
                    this.validationMessage = error.response.data.message
                } else {
                    this.validationMessage = 'Failed to update tags'
                }
            }
        }
    }
}
</script>